import { z } from 'zod';

/** Contratos de Tags (M2). */

export const tagSchema = z.object({
  id: z.string(),
  name: z.string(),
  archived: z.boolean(),
});
export type Tag = z.infer<typeof tagSchema>;

export const tagsResponseSchema = z.object({ tags: z.array(tagSchema) });
export type TagsResponse = z.infer<typeof tagsResponseSchema>;

export const createTagBodySchema = z.object({
  name: z.string().trim().min(1, 'Informe o nome da tag.').max(40),
});
export type CreateTagBody = z.infer<typeof createTagBodySchema>;

export const updateTagBodySchema = createTagBodySchema;
export type UpdateTagBody = z.infer<typeof updateTagBodySchema>;
